export default "__VITE_ASSET__DOpHK20Q__"